import moment from 'moment';
import React from 'react'
import { MoneyLogCell } from '../../../../../components/MoneyLogLines'

const KIND_LABEL = {
  vietlott: 'Vietlott',
  classic: 'Kiến thiết',
  loto: 'Loto',
}

const GAME_LABEL = {
  keno: 'Keno',
  mega: 'Mega 6/45',
  power: 'Power 6/55',
  max3d: 'Max3D',
  max3dpro: 'Max3D Pro',
  lotto535: 'Lotto 5/35',
}

const SOURCE_LABEL = {
  order: 'Toàn đơn',
  tickets: 'Vé',
  partial: 'Một phần vé',
  cart: 'Đơn',
  ticket: 'Vé',
}

export const TableRow = (props) => {
  const { id, amount, user, createdAt, reason, kind, source, mode, cartId, ticketId, gameId, moneyLog } = props;
  const phone = (user && user.phone && user.phone.replace('+84', '0')) || ""
  const game = GAME_LABEL[gameId] || gameId || ""
  const sourceText = SOURCE_LABEL[mode] || SOURCE_LABEL[source] || ""

  return (
    <tr>
      <td>
        {(user && user.name) || ""}<br />
        <span><strong className="text-primary">{phone}</strong></span>
      </td>
      <td>
        {KIND_LABEL[kind] || kind || ""}
        {game ? <><br /><span>{game}</span></> : null}
      </td>
      <td className="text-center">{sourceText}</td>
      <td>{cartId || ""}</td>
      <td>{ticketId || ""}</td>
      <td className="fw-900 text-success text-right" style={{ whiteSpace: 'nowrap' }}>{new Intl.NumberFormat('vn-VI', {}).format(amount) || ""}</td>
      <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{reason || ""}</td>
      <MoneyLogCell moneyLog={moneyLog} expectedType="TransactionCashBack" expectedId={id} />
      <td className="text-center">{moment(createdAt || '').format('DD/MM/YYYY HH:mm:ss')}</td>
    </tr>
  );
};
